import {
  Box,
  Flex,
  Text,
  Link,
  Input,
  Stack,
  Button,
  Heading,
  useToast,
  FormLabel,
  FormControl,
  useColorModeValue,
} from "@chakra-ui/react";
import axios from "axios";
import React, { useState } from "react";
import UserDetails from "./UserDetails";
import { useNavigate } from "react-router-dom";

const Login = () => {
  const toast = useToast();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [isValidEmail, setIsValidEmail] = useState(true);
  const [password, setPassword] = useState(null);
  const [users, setUsers] = useState([]);
  const [isValidUser, setIsValidUser] = useState(false);

  const handleEmailChange = (e) => {
    const value = e.target.value;
    setEmail(value);
    validateEmail(value);
  };

  const validateEmail = () => {
    const emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
    setIsValidEmail(emailPattern.test(email));
  };

  const handleLogin = (e) => {
    e.preventDefault();

    let userLoginObj = {
      email: email,
      password: password,
    };

    if (email === "" || password === "") {
      toast({
        title: "All fields required to fulfill",
        status: "warning",
        duration: 2000,
        isClosable: true,
      });
    } else if (!isValidEmail) {
      toast({
        title: "Invalid email",
        status: "error",
        duration: 2000,
        isClosable: true,
      });
    } else {
      axios
        .get("https://user-auth-wfn4.onrender.com/users")
        .then((res) => setUsers(res.data))
        .catch((err) => {
          toast({
            title: "Data Get Error",
            status: "error",
            duration: 2000,
            isClosable: true,
          });
        });

      users.map((el) => {
        if (
          el.email === userLoginObj.email &&
          el.password === userLoginObj.password
        ) {
          setIsValidUser(true);
        }
      });

      if (isValidUser) {
        toast({
          title: "Hurray, Login Successfully ....",
          status: "success",
          duration: 3000,
          isClosable: true,
        });

        localStorage.setItem("userEmail", email);
        localStorage.setItem("userPassword", password);
        navigate("/userdetails");
      } else {
        toast({
          title: "Wrong Crendentials",
          status: "warning",
          duration: 2000,
          isClosable: true,
        });
        console.log(userLoginObj);
      }
    }
  };

  return (
    <Flex
      minH={"100vh"}
      align={"center"}
      justify={"center"}
      bg={useColorModeValue("gray.50", "gray.800")}
    >
      <Stack spacing={8} w={{ base: "90%", md: "40%" }} py={12} px={6}>
        <Stack align={"center"}>
          <Heading
            fontSize={"4xl"}
            textAlign={"center"}
            color={"saddlebrown "}
            textDecoration={"underline"}
          >
            Login
          </Heading>
        </Stack>
        <Box
          rounded={"lg"}
          bg={useColorModeValue("white", "gray.700")}
          boxShadow={"lg"}
          p={8}
        >
          <Stack spacing={4}>
            <FormControl id="email">
              <FormLabel>Email address</FormLabel>
              <Input
                type="email"
                name="email"
                autoComplete="off"
                onChange={handleEmailChange}
              />
            </FormControl>

            <FormControl id="password">
              <FormLabel>Password</FormLabel>
              <Input
                type="password"
                name="password"
                autoComplete="off"
                onChange={(e) => setPassword(e.target.value)}
              />
            </FormControl>

            <Stack spacing={10}>
              <Button
                bg={"blue.400"}
                color={"white"}
                _hover={{
                  bg: "blue.500",
                }}
                onClick={handleLogin}
              >
                Login
              </Button>
            </Stack>

            <Stack pt={6}>
              <Text align={"center"}>
                Already not a valid user?{" "}
                <Link color={"blue.400"} onClick={() => navigate("/register")}>
                  Register
                </Link>
              </Text>
            </Stack>
          </Stack>
        </Box>
      </Stack>
    </Flex>
  );
};

export default Login;
